/**
 * Contrat de données route.v1.json (PLAN.md §3), produit par tools/build_route.py.
 * PK = index × step_m : une gare est un simple entier.
 */
export interface RouteStation {
  idx: number;
  name: string;
  detail: string | null;
  express: boolean;
}

export interface RouteLandmark {
  idx: number;
  name: string;
}

export interface RouteData {
  version: 1;
  id: string;
  label: string;
  variant: { nord: string; ouest: string };
  source: string;
  extracted: string;
  step_m: number;
  length_m: number;
  hypotheses: {
    vmax_line_kmh: number;
    a_lat_ms2: number;
    curvature_window_m: number;
    imax: number;
    ouvrage_threshold_m: number;
    profile: string;
  };
  /** [lon, lat] WGS84, un point par pas */
  coords: [number, number][];
  z_terrain: number[];
  z_rail: number[];
  /** pente algébrique par segment (n−1 valeurs) */
  grade: number[];
  /** 0 au sol · 1 viaduc/remblai · −1 tunnel/déblai */
  ouvrage: number[];
  /** limitation par point, km/h */
  vmax_kmh: number[];
  vmax_overrides: { from_idx: number; to_idx: number; vmax_kmh: number; reason: string }[];
  termini: [string, string];
  landmarks: RouteLandmark[];
  reference_stations: RouteStation[];
  /** commune de chaque point, par plages */
  communes: { from_idx: number; name: string }[];
}

export interface RouteIndexEntry {
  id: string;
  label: string;
  nord: string;
  ouest: string;
  length_m: number;
  stations: number;
  file: string;
  t_ref_min: number;
}

export interface RouteIndex {
  reference: string;
  extracted: string;
  routes: RouteIndexEntry[];
}

/** Nombre de points de la grille. */
export function pointCount(r: RouteData): number {
  return r.coords.length;
}

/** Commune du point idx. */
export function communeAt(r: RouteData, idx: number): string | null {
  let name: string | null = null;
  for (const c of r.communes) {
    if (c.from_idx > idx) break;
    name = c.name;
  }
  return name;
}

/** PK (m) d'un index. */
export function pkOf(r: RouteData, idx: number): number {
  return idx * r.step_m;
}
